import React from "react";
import { XCircleIcon } from "@phosphor-icons/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateConversation } from "api/conversations";
import { useFeedback } from "contexts/feedback";
import Button from "components/Button";

export default function ConversationRenamePopup({
    visible,
    setVisible,
    conversation
}) {

    const cache = useQueryClient();
    const { setSuccess, setError } = useFeedback();

    const { mutate, status } = useMutation({
        mutationKey: ['updateConversation'],
        mutationFn: updateConversation,
        onSuccess: () => {
            setSuccess('Conversazione rinominata con successo');
            cache.invalidateQueries(['conversations']);
            setTimeout(() => setVisible(false), 1000);
        },
        onError: (error) => {
            console.error("Error updating conversation:", error);
            setError('Errore durante la rinomina della conversazione');
        }
    });

    const onSubmitHandler = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const name = formData.get('name');

        if (!name || name.trim() === '') {
            setError('Il nome non può essere vuoto');
            return;
        }

        mutate({
            id: conversation._id,
            body: { name: name.trim() }
        });
    }

    if (!visible) return null;

    return (
        <div className="fixed z-[var(--z-modal)] flex top-0 left-0 lg:left-[320px] right-0 bottom-0 items-center justify-center transition-all backdrop-blur-sm">
            <div className="absolute top-0 left-0 right-0 bottom-0 bg-white/20 transition-all duration-300 ease-in-out flex items-center justify-center" onClick={() => setVisible(false)}></div>

            <div className="relative max-w-[90vw] w-full max-w-[450px] max-h-[87vh] bg-white rounded-3xl transition-all duration-300 ease-in-out flex flex-col">
                <div className="w-full border-b border-black/6 px-6 py-4 flex justify-between items-center">
                    <p className="text-black font-medium">Rinomina conversazione</p>

                    <div className="p-1" onClick={() => setVisible(false)}>
                        <XCircleIcon size={28} className="fill-black cursor-pointer hover:fill-black/80 transition-all duration-300 ease-in-out" />
                    </div>
                </div>

                <form onSubmit={onSubmitHandler}>
                    <div className="flex-1 w-full overflow-y-scroll pb-18 px-6 py-6">
                        <input
                            type="text"
                            name="name"
                            id="name"
                            defaultValue={conversation.name}
                            placeholder="Titolo della conversazione"
                            className="block w-full bg-transparent text-black placeholder:text-black/50 focus:outline-none resize-none text-[16px] leading-[1.55] border-b border-black/10 pb-3"
                            autoFocus
                        />
                    </div>

                    <Button
                        className="w-full border-t border-black/6 py-6 rounded-none"
                        submit
                        status={status}
                        autoResetStatus={false}
                    >
                        Conferma
                    </Button>
                </form>
            </div>
        </div>
    )
}
